function serviceBlockSlider(desktopItems) {
  [...document.querySelectorAll('.services-block-slider')]?.forEach( slider => {
    new Splide( slider, {
      speed: 1000,
      perPage: 1,
      perMove: 1,
      gap: '0.75rem',
      autoHeight: true,
      lazyload: 'sequential',
      mediaQuery: 'min',
      breakpoints: {
        782: {
          perPage: 2,
          perMove: 2,
        },
        1200: {
          perPage: desktopItems,
          perMove: 2,
          gap: '2rem',
          drag: false
        },
      }
    } ).mount();

    // Count slider elements and add class for desktop
    let sliderItems = slider.querySelectorAll('.splide__slide').length;

    if ( sliderItems <= 4 ) {
      slider.classList.add('services-block-slider--alternative');
    }
  })
}

document.addEventListener( 'DOMContentLoaded', function() {
  serviceBlockSlider(4);
} );
